module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question-textarea"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("\n            " + _vm._s(_vm.question.content) + "\n        ")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.question.answer),
      expression: "question.answer",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-group__textarea",
    attrs: {
      "placeholder": "Fill in your answer here ..."
    },
    domProps: {
      "value": (_vm.question.answer)
    },
    on: {
      "blur": [function($event) {
        return _vm.setAnswer()
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.question, "answer", $event.target.value.trim())
      }
    }
  }), (_vm.question.info) ? _c('div', {
    staticClass: "question-caption mt-15 pb-15"
  }, [_c('div', {
    staticClass: "question-caption__content",
    domProps: {
      "innerHTML": _vm._s(_vm.question.info)
    }
  })]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-95526e26","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/question-textarea.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-95526e26","preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/question-textarea.vue
// module chunks = 0